import React from 'react'

const CalenderAddIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 14.334H2.25C1.764 14.334 1.35067 14.164 1.01 13.824C0.67 13.4833 0.5 13.07 0.5 12.584V3.58397C0.5 3.09797 0.67 2.68497 1.01 2.34497C1.35067 2.0043 1.764 1.83397 2.25 1.83397H3V0.167969H4.75V1.83397H9.583V0.167969H11.333V1.83397H12.083C12.569 1.83397 12.9823 2.0043 13.323 2.34497C13.663 2.68497 13.833 3.09797 13.833 3.58397V8.54297C13.6803 8.51497 13.5347 8.49397 13.396 8.47997C13.2573 8.46597 13.1113 8.45897 12.958 8.45897C12.8053 8.45897 12.6597 8.46597 12.521 8.47997C12.3817 8.49397 12.2357 8.51497 12.083 8.54297V6.08397H2.25V12.584H8C7.972 12.7366 7.95133 12.8826 7.938 13.022C7.924 13.1606 7.917 13.3063 7.917 13.459C7.917 13.6123 7.924 13.7583 7.938 13.897C7.95133 14.0356 7.972 14.1813 8 14.334ZM12.083 16.834V14.334H9.583V12.584H12.083V10.084H13.833V12.584H16.333V14.334H13.833V16.834H12.083Z"
        fill="#B3B7C1"
      />
    </svg>
  )
}

export default CalenderAddIcon
